import { render, staticRenderFns } from "./ProviderUserFilter.vue?vue&type=template&id=788ab60e&scoped=true"
import script from "./ProviderUserFilter.vue?vue&type=script&lang=js"
export * from "./ProviderUserFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788ab60e",
  null
  
)

export default component.exports